import { ChangeEvent, ReactNode } from "react"
import TextInput from "@/components/shared/TextInput"
import Tooltip, { TooltipPosition } from "@/components/shared/Tooltip"

const EditableCell = ({
   children,
   isEditing,
   value,
   type,
   name,
   error,
   content,
   min,
   onChange,
}: {
   children: ReactNode
   isEditing: boolean
   value: string
   type: string
   name: string
   content: string
   error: boolean
   min: number
   onChange: (e: ChangeEvent<HTMLInputElement>) => void
}) => {
   return (
      <>
         {isEditing ? (
            <Tooltip
               content={content}
               open={error}
               position={TooltipPosition.RIGHT}
            >
               <TextInput
                  name={name}
                  type={type}
                  onChange={onChange}
                  min={min}
                  value={value}
                  error={error}
               />
            </Tooltip>
         ) : (
            children
         )}
      </>
   )
}

export default EditableCell
